import axios from 'axios'
import head from 'lodash/head'
import compose from 'lodash/fp/compose'
import map from 'lodash/fp/map'
import { load_one, load_many, _get_counts } from '../action-helpers'
import http from '@/http'

// noinspection JSUnusedGlobalSymbols
export default {

    /**
     * Lädt genau eine Seite Unternehmen vom Server (server-seitige Paginierung).
     * Gibt das Array der Unternehmen dieser Seite zurück.
     */
    async loadPage({ commit }, { page = 0, size = 20, type } = {}) {
        const params = { page, size }
        if (type === 'PURCHASER') params.isPurchaser = true
        if (type === 'SUPPLIER')  params.isSupplier  = true
        if (type === 'AGENCY')    params.isAgency    = 1
        const response = await http({ method: 'GET', url: 'companies', params })
        const companies = response.data.content
        commit('SET_MANY', { content: companies })
        commit('SET_COUNTS', { content: _get_counts(response.headers) })
        return companies
    },

    create({ dispatch }, { model }) {
        return axios.post('/api/v1/companies', model).then(response => {
            return Promise.all([
                dispatch('loadOne', { id: response.data.id }),
                dispatch('loadAll', { force: true }),
                dispatch('addresses/loadAll', { force: true }, { root: true }),
                dispatch('persons/loadAll', { force: true }, { root: true }),
                dispatch('users/loadAll', { force: true }, { root: true })
            ]).then(head)
        })
    },

    loadAll: load_many('companies', { setCounts: true }),
    loadAllByIsAgencyOfCompanyId: load_many('companies/:companyId/agencies'),
    loadAllByIsAgency: load_many('companies', { params: { isAgency: 1 } }),
    loadAllByIsPurchaser: load_many('companies', { params: { isPurchaser: 1 } }),
    loadAllByIsSupplier: load_many('companies', { params: { isSupplier: 1 } }),
    loadAllByJobId: load_many('jobs/:jobId/companies'),
    loadOne: load_one('companies/:id'),
    loadOneByUserId: load_one('users/:userId/company'),
    loadZmuek: load_one('companies/2'),

    loadAllByIds({ dispatch }, { ids, force }) {
        return Promise.all(
            ids.map(id => dispatch('loadOne', { id, force }))
        )
    },

    loadAllByJobModels({ dispatch }, { jobModels, params = {}, force}) {
        return compose(

            // Promises zusammenfassen
            promises => Promise.all(promises),

            // Unternehmen einzeln laden
            map(jobModel => dispatch('loadOne', { id: jobModel.supplier, params, force }))

        )(jobModels)
    },

    patch({ dispatch }, { model }) {
        // Unternehmen laden
        return dispatch('loadOne', { id: model.id }).then(dbModel =>

            // Unternehmen mit `model` mergen und speichern
            dispatch('update', { model: Object.assign({}, dbModel, model) })

        )
    },

    update({ dispatch }, { model }) {
        return axios.put(`/api/v1/companies/${model.id}`, model).then(() => {
            return Promise.all([
                dispatch('loadOne', { id: model.id, force: true }),
                dispatch('loadAll', { force: true }),
            ]).then(head)
        })
    },

}
